// extracted by mini-css-extract-plugin
export var banner = "Collaborations-module--banner--accc6";
export var collaboration = "Collaborations-module--collaboration--14b41";
export var collaborations = "Collaborations-module--collaborations--65c4f";
export var desktop = "Collaborations-module--desktop--679f7";
export var heading = "Collaborations-module--heading--39e19";
export var mobile = "Collaborations-module--mobile--ac809";